export const showCaseData = {
  companies: [
    "facebook",
    "amazon",
    "microsoft",
    "apple",
    "google",
    "airbnb",
    "spotify",
    "yahoo",
    "netflix",
  ],
};
